module.exports = __webpack_public_path__ + "static/img/noDataPic.b55e5697.png";